// extracted by mini-css-extract-plugin
export var columnList = "_fg-0";